import App from './App.vue';
import router from '@/router';
import store from '@/store';
import 'amfe-flexible';
import 'vant/lib/index.css';
import '@/styles/index.less';
import { Lazyload } from 'vant';
// import sensors from '@/utils/sensors_config'
import draggable from '@/utils/draggable';
// (window as any).$sensors = sensors
const app = createApp(App);
app.directive('draggable', draggable);

app.use(Lazyload);
app.use(router);
app.use(store);

app.mount('#app');
